import {autoUpdate, flip, offset, size, useDismiss, useFloating, useInteractions} from '@floating-ui/react';

import {Placement, useClickAway} from 'common';

import type {DropdownProps} from './types';

const targetSize = size({
  apply({rects, elements}) {
    elements.floating.style.width = `${rects.reference.width}px`;
  },
});

export const useDropdown = (props: DropdownProps) => {
  const {
    isOpen,
    setIsOpen,
    setFloating,
    targetRef,

    middleware = [
      props.offset ? offset(props.offset) : undefined,
      props.width === 'target' ? targetSize : undefined,
      flip(),
    ],

    placement = Placement.Bottom,
  } = props;

  const floating = useFloating({
    middleware,
    placement,

    open: isOpen,
    onOpenChange: setIsOpen,
    whileElementsMounted: autoUpdate,

    elements: {reference: targetRef.current},
  });

  setFloating?.(floating);

  const interactions = useInteractions([
    useDismiss(floating.context, {
      escapeKey: props.closeOnEscape,
      outsidePress: props.closeOnOverlay,
      outsidePressEvent: 'click',
    }),
  ]);

  useClickAway(
    () => {
      setIsOpen(false);
    },
    targetRef,
    floating.refs.floating
  );

  return {interactions, floating};
};
